import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { fetchNotifyEtiquette, fetchNotify, fetchNotifyGet, fetchNotifyList, updateCurrentHouseNo, updateToggle, updateRouteHouseNo } from '@Root/slices/myhouse/notifySlice'
import { RootState } from '@Root/slices'

export default function useNotify() {
  const dispatch = useDispatch()
  const reduxNotify = useSelector((state: RootState) => state.notify)

  const loadNotifyList = useCallback(() => {
    dispatch(fetchNotifyList())
  }, [dispatch])

  const loadNotifyGet = useCallback(
    (houseNo: number) => {
      dispatch(fetchNotifyGet(houseNo))
    },
    [dispatch],
  )

  const loadNotify = useCallback(
    (param: { houseNo: number; notifyYn: boolean; [p: string]: number | boolean }) => {
      dispatch(fetchNotify(param))
    },
    [dispatch],
  )

  const loadNotifyEtiquette = useCallback(
    (param: { etiquetteYn: boolean }) => {
      dispatch(fetchNotifyEtiquette(param))
    },
    [dispatch],
  )

  const setToggle = useCallback(
    (param: { key: string; value: boolean }) => {
      dispatch(updateToggle(param))
    },
    [dispatch],
  )

  const setCurrentHouseNo = useCallback(
    (param: { currentHouseNo: number }) => {
      dispatch(updateCurrentHouseNo(param))
    },
    [dispatch],
  )

  const setRouteHouseNo = useCallback(
    (routeHouseNo: number) => {
      dispatch(updateRouteHouseNo(routeHouseNo))
    },
    [dispatch],
  )

  return {
    reduxNotify,
    loadNotifyList,
    loadNotifyGet,
    loadNotify,
    loadNotifyEtiquette,
    setToggle,
    setCurrentHouseNo,
    setRouteHouseNo,
  }
}
